import { formatTimeLabel } from "./formatTimeLabel";

export type TimeRange = {
  timeGTE?: string;
  timeLTE?: string;
};

export const timeRangeLabel = (times?: TimeRange): string | null => {
  if (!times || !times.timeGTE || !times.timeLTE) {
    return null;
  }

  const startTime = formatTimeLabel(times.timeGTE);
  const endTime = formatTimeLabel(times.timeLTE);

  if (!startTime || !endTime) {
    return null;
  }

  return `${startTime} - ${endTime}`;
};
